import { render, staticRenderFns } from "./eduList.vue?vue&type=template&id=1c46f84d&scoped=true"
import script from "./eduList.vue?vue&type=script&lang=js"
export * from "./eduList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c46f84d",
  null
  
)

export default component.exports